import { Reducer } from 'redux';
import _ from 'lodash';
import { IReduxAction } from 'app/types/actions';
import { ReportsActionTypes as types, IReportsState } from './types';

const initialState: IReportsState = {
  reportsById: {},
  reportIds: [],
  currentReportId: undefined,
  isLoading: false,
  isSaving: false,
  hasLoaded: false,
  hasSaved: false,
  hasFailed: false,
  requestedData: {},
  backendErrors: {},
};

const reducer: Reducer<IReportsState> = (
  state = initialState,
  action: IReduxAction,
) => {
  switch (action.type) {
    case types.CREATE_PAYOUT_SUMMARY_REPORT_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.CREATE_PAYOUT_SUMMARY_REPORT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        requestedData: {},
        reportsById: _.merge({}, state.reportsById, action.payload.reportsById),
        reportIds: _.union(state.reportIds, [action.payload.currentReportId]),
        currentReportId: action.payload.currentReportId,
        backendErrors: {},
      };
    }
    case types.CREATE_PAYOUT_SUMMARY_REPORT_FAIL: {
      return {
        ...state,
        isSaving: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    case types.CREATE_PAYOUT_DETAILED_REPORT_PENDING: {
      return {
        ...state,
        isSaving: true,
        hasSaved: false,
        hasFailed: false,
        requestedData: action.payload,
        backendErrors: {},
      };
    }
    case types.CREATE_PAYOUT_DETAILED_REPORT_SUCCESS: {
      return {
        ...state,
        isSaving: false,
        hasSaved: true,
        requestedData: {},
        reportsById: _.merge({}, state.reportsById, action.payload.reportsById),
        reportIds: _.union(state.reportIds, [action.payload.currentReportId]),
        currentReportId: action.payload.currentReportId,
        backendErrors: {},
      };
    }
    case types.CREATE_PAYOUT_DETAILED_REPORT_FAIL: {
      return {
        ...state,
        isSaving: false,
        backendErrors: action.payload.backendErrors,
      };
    }
    default:
      return state;
  }
};

export default reducer;
